// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3wg9f","large":"styles_large__2wv-q"};